module.exports = __webpack_public_path__ + "img/bell.6aacf718.svg";